const vat_rates = {
    serbia: 0.2
}
export const getVatRate = (country) => {
    country = country.toLowerCase();

    return vat_rates[country] ? vat_rates[country] : 0;
}
